import classes from './Layout.module.css'

export function SimpleLayout({ children }) {
  return <div className={classes.simpleLayout}>{children}</div>
}
export function SimpleForm({ children }) {
  return <div className={classes.simpleForm}>{children}</div>
}
